import set from 'lodash/fp/set';

import { createReducer } from 'utils/reduxUtils';

import { PRESELECTION_RESET, PRODUCT_PRESELECTED } from './actionTypes';
import initialState from './initialState';

const reducerToActionTypeMap = {
  [PRODUCT_PRESELECTED]: (state, { payload }) => set('preselected', payload)(state),
  [PRESELECTION_RESET]: set('preselected', null),
};

export const origin = createReducer(reducerToActionTypeMap, initialState);
